module.exports = __webpack_public_path__ + "media/images/landing__leaguesTeaser-7f23cf150c603c8715ee8ac4dfb00f5b.jpg";